import { MD5 } from 'crypto-js';
import { sortObjByKey } from "./index";
//系统为调用方分配Appkey（访问标识）和AppSecret（用于签名加密）。


// Appkey（访问标识）
export const getAppKey = "6bwktuqcilbhkumemc";
// AppSecret（用于签名加密）
export const getAppSecret = "owba9kydim0tpsu1knvoxbs9h2qebthr";

// 时间戳
export const getTimestamp = () => {
    return new Date().getTime();
};

// 6位随机数
export const getNonce = () => {
    return Math.random().toString(36).substr(2, 6);
};

// 签名
export const encrypt = (params) => {
    let paramsJson;
    paramsJson = params;
    const appkey = getAppKey;
    const timestamp = getTimestamp();
    const nonce = getNonce();
    const crypto = {
        timestamp,
        appkey,
        nonce,
    };
    // sign值
    const sign = md5Crypto(paramsJson, crypto);
    delete paramsJson.signField;
    
    let obj={...{...crypto,sign},...paramsJson}
    console.log(obj);

    return obj

};

// 处理签名字段 MD5加密
const md5Crypto = (paramsJson, crypto) => {
    const { signField } = paramsJson;
    // 获取需要签名的字段
    const cryptoParams = {
        ...crypto,
    };
    signField.map((item) => {
        cryptoParams[item] = paramsJson[item];
        return null;
    });

    // 排序
    const cryptoSort = sortObjByKey(cryptoParams);

    // 字符拼接
    let cryptoStr = "";
    Object.keys(cryptoSort).map((item) => {
        // console.log(item);
        // console.log(typeof cryptoSort[item], "type of");
        cryptoStr += typeof cryptoSort[item] == 'object' ? JSON.stringify(cryptoSort[item]) : cryptoSort[item];
    });
    cryptoStr += getAppSecret;
    // console.log(cryptoStr, 'cryptoStr');
    // md5加密
    const md5CryptoUpper = MD5(cryptoStr).toString().toLocaleUpperCase();
    return md5CryptoUpper;
};



// WEBPACK FOOTER //
// ./src/assets/js/encrypt.js